/**
 * GuidanceSection component - Reusable card wrapper for guidance content.
 * Displays an icon, title, and content slot with consistent styling.
 */

import React from 'react';

interface GuidanceSectionProps {
  icon: string;
  title: string;
  children: React.ReactNode;
  variant?: 'default' | 'highlight' | 'subtle';
}

const VARIANT_STYLES: Record<string, string> = {
  default: 'bg-white border border-neutral-200',
  highlight: 'bg-gradient-to-br from-primary-50 to-white border border-primary-200',
  subtle: 'bg-neutral-50 border border-neutral-200',
};

const GuidanceSection: React.FC<GuidanceSectionProps> = ({
  icon,
  title,
  children,
  variant = 'default',
}) => {
  return (
    <div className={`rounded-xl p-5 ${VARIANT_STYLES[variant]}`}>
      <div className="flex items-start space-x-3 mb-3">
        <span className="text-2xl flex-shrink-0">{icon}</span>
        <h3 className="text-lg font-semibold text-neutral-900">{title}</h3>
      </div>
      <div className="text-neutral-700 leading-relaxed">
        {children}
      </div>
    </div>
  );
};

export default GuidanceSection;